/*
 * @Author: Json Chen
 * @Date: 2021-07-13 14:23:59
 * @LastEditTime: 2022-06-23 15:38:31
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/CourierAccount/setting.tsx
 */

import { Button, Image } from '@/src/components/Antd';
import CommonHeader from '@/src/components/CommonHeader';
import Configuration from '@/src/components/Configuration/Configuration';
import {
  getCourierDetail,
  setCourier,
} from '@/src/request/settings/logistics/courieraccount';
import {
  getWareHouseLocation,
  getApiAddress,
} from '@/src/request/settings/logistics/wareHouseLocation';
import { useRequest } from 'ahooks';
import { Form, Input, Spin } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { breadcrumbData } from '../config';
import CourierAccountInformation from './CourierAccountInformation';
import { LabelA4, LabelThermal } from './images';
import styles from './style.module.less';
import { transformTypeReq, transformTypeRes } from './tools';
import { CourierType, SFLocation } from './type';
//import WaybillNumber from './WaybillNumber';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { OriSelect } from 'src/components/Antd';
import { get } from 'lodash';

const Option = OriSelect.Option;

const SFFormItems = (location, data) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  return (
    <React.Fragment>
      <div className={styles.itemBlock}>
        <div className={styles.header}>
          <div className={styles.title}>
            {getI18n('storeLogistics.courierAccount.sFExpressQiaoAPI')}
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.formItemTwoInOne}>
            <Form.Item
              className={styles.formItemTwoInOneItem}
              label={<div className={styles.labelTitle}>{'Api Server'}*</div>}
              name={'apiServerAddress'}
              rules={[
                {
                  required: true,
                },
              ]}>
              <OriSelect size='large'>
                {(data || []).map((i) => {
                  const serverAddress = get(i, 'serverAddress');
                  return (
                    <Option value={serverAddress} key={serverAddress}>
                      {serverAddress}
                    </Option>
                  );
                })}
              </OriSelect>
            </Form.Item>
          </div>
          <div className={styles.formItemTwoInOne}>
            <Form.Item
              className={styles.formItemTwoInOneItem}
              label={
                <div className={styles.labelTitle}>
                  {getI18n('storeLogistics.courierAccount.clientCode')}*
                </div>
              }
              name={'clientCode'}
              rules={[
                {
                  required: true,
                },
              ]}>
              <Input size='large' />
            </Form.Item>
            <Form.Item
              className={styles.formItemTwoInOneItem}
              label={
                <div className={styles.labelTitle}>
                  {getI18n('storeLogistics.courierAccount.checkWord')}*
                </div>
              }
              name={'checkWord'}
              rules={[
                {
                  required: true,
                },
              ]}>
              <Input size='large' />
            </Form.Item>
          </div>
        </div>
      </div>

      <div className={styles.itemBlock}>
        <div className={styles.header}>
          <div className={styles.title}>
            {getI18n('storeLogistics.courierAccount.sFExpressDeliveryAPI')}
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.formItemTwoInOne}>
            <Form.Item
              className={styles.formItemTwoInOneItem}
              label={
                <div className={styles.labelTitle}>
                  {getI18n('storeLogistics.courierAccount.customerID')}*
                </div>
              }
              name={'customerId'}
              rules={[
                {
                  required: true,
                },
              ]}>
              <Input size='large' />
            </Form.Item>
            <Form.Item
              className={styles.formItemTwoInOneItem}
              label={
                <div className={styles.labelTitle}>
                  {getI18n('storeLogistics.courierAccount.trackingURL')}*
                </div>
              }
              extra={
                <div className={styles.formExtra}>
                  <span>
                    {getI18n('storeLogistics.courierAccount.marcoAvailable')}
                  </span>
                  <span className={styles.hasBgText}>
                    {getI18n('storeLogistics.courierAccount.waybillNumber')}
                  </span>
                </div>
              }
              name={'trackingUrl'}
              rules={[
                {
                  required: true,
                },
              ]}>
              <Input
                size='large'
                placeholder={
                  'e.g. https://htm.sf-express.com/{{waybillNumber}}'
                }
              />
            </Form.Item>
          </div>
          <div>
            {location === SFLocation.HK_MO && (
              <Configuration
                configStart={getI18n(
                  'storeLogistics.courierAccount.sFFormItemsConfiguration',
                )}
                configLink={getI18n('storeLogistics.config.logistics')}
                configEnd={getI18n('storeLogistics.courierAccount.tosetup')}
              />
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const ZTOFormItems = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <React.Fragment>
      <div className={styles.itemBlock}>
        <div className={styles.header}>
          <div className={styles.title}>
            {getI18n('storeLogistics.courierAccount.zTOExpressDeliveryAPI')}
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.formItemTwoInOne}>
            <Form.Item
              className={styles.formItemTwoInOneItem}
              label={
                <div className={styles.labelTitle}>
                  {getI18n('storeLogistics.courierAccount.token')}*
                </div>
              }
              name={'deliveryToken'}
              rules={[
                {
                  required: true,
                },
              ]}>
              <Input size='large' />
            </Form.Item>
            <Form.Item
              className={styles.formItemTwoInOneItem}
              label={
                <div className={styles.labelTitle}>
                  {getI18n('storeLogistics.courierAccount.tokenKey')}*
                </div>
              }
              name={'deliveryTokenKey'}
              rules={[
                {
                  required: true,
                },
              ]}>
              <Input size='large' />
            </Form.Item>
            <Form.Item
              className={styles.formItemTwoInOneItem}
              label={
                <div className={styles.labelTitle}>
                  {getI18n('storeLogistics.courierAccount.warehouseCode')}*
                </div>
              }
              name={'deliveryWarehouseCode'}
              rules={[
                {
                  required: true,
                },
              ]}>
              <Input size='large' />
            </Form.Item>
          </div>
        </div>
      </div>
      <div className={styles.itemBlock}>
        <div className={styles.header}>
          <div className={styles.title}>
            {getI18n('storeLogistics.courierAccount.zTOExpressTrackingAPI')}
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.formItemTwoInOne}>
            <Form.Item
              className={styles.formItemTwoInOneItem}
              label={
                <div className={styles.labelTitle}>
                  {getI18n('storeLogistics.courierAccount.clientSource')}*
                </div>
              }
              name={'trackClientSource'}
              rules={[
                {
                  required: true,
                },
              ]}>
              <Input size='large' />
            </Form.Item>
            <Form.Item
              className={styles.formItemTwoInOneItem}
              label={
                <div className={styles.labelTitle}>
                  {getI18n('storeLogistics.courierAccount.tokenKey')}*
                </div>
              }
              name={'trackTokenKey'}
              rules={[
                {
                  required: true,
                },
              ]}>
              <Input size='large' />
            </Form.Item>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const ShippingLabelItem = ({ image, title, desc, onClick }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <div className={styles.formItemTwoInOneItem}>
      <div className={styles.contentItemContent}>
        <Image src={image}></Image>
        <div className={styles.contentItemContentText}>
          <span className={styles.contentItemContentTextTitle}>{title}</span>
          <span>{desc}</span>
        </div>
      </div>
      <Button className={styles.contentItemBtn} onClick={onClick}>
        {getI18n('storeLogistics.courierAccount.printTestLabel')}
      </Button>
    </div>
  );
};

const ShippingLabel = ({ title = '' }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const shippingList = [
    {
      image: LabelA4,
      title: 'A4 (210 x 297mm)',
      desc: getI18n('storeLogistics.courierAccount.a4Desc'),
    },
    {
      image: LabelThermal,
      title: `${getI18n(
        'storeLogistics.courierAccount.thermal',
      )} (4 X 6 inch/ 100 x 150mm / A6)`,
      desc: getI18n('storeLogistics.courierAccount.a6Desc'),
    },
  ];

  const onButtonClick = (item, index) => {
    console.log('item,index: ', item, index);
  };

  return (
    <div className={styles.itemBlock}>
      <div className={styles.header}>
        <div className={styles.title}>
          {title}{' '}
          {getI18n('storeLogistics.courierAccount.expressShippingLabel')}
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.contentItem}>
          <div className={styles.contentHeader}>
            {getI18n('storeLogistics.courierAccount.generalLabel')}
          </div>
          <div className={styles.formItemTwoInOne}>
            {shippingList.map((item, index) => (
              <ShippingLabelItem
                key={index}
                {...item}
                onClick={() => onButtonClick(item, index)}
              />
            ))}
          </div>
        </div>
        <div className={styles.contentItem}>
          <div className={styles.contentHeader}>
            {getI18n('storeLogistics.courierAccount.cN22Label')}
          </div>
          <div className={styles.formItemTwoInOne}>
            {shippingList.map((item, index) => (
              <ShippingLabelItem
                key={index}
                {...item}
                onClick={() => onButtonClick(item, index)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const CourierAccountSetting = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const history = useHistory();

  const { uuid, type, location, warehouseUuid } = useParams() as any;

  if (!CourierType[type]) {
    return (
      <div>{getI18n('storeLogistics.courierAccount.incorrectCourierType')}</div>
    );
  }

  const [form] = Form.useForm();

  // const warehouseList = _warehouseList.slice(0, 1);
  const [onSaveDisable, setOnSaveDisable] = useState<boolean>(true);
  const [addressLoaded, setAddressLoaded] = React.useState(false);
  const { data } = useRequest(getApiAddress, {
    onSuccess: () => {
      setAddressLoaded(true);
    },
  });
  const defaultAddress = get(
    (data || []).filter((i) => get(i, 'defaultAddress')),
    '0.serverAddress',
  );
  const CourierAccountStrategy = {
    [CourierType.SF]: SFFormItems(location, data),
    [CourierType.ZTO]: ZTOFormItems(),
  };

  const {
    loading: locationLoading,
    data: { locationName: warehouseName = '' } = {},
  } = useRequest(() => getWareHouseLocation(warehouseUuid));

  const _breadcrumbData = useMemo(() => {
    const breadcrumbDataCopy = breadcrumbData({ getI18n }).concat({
      url: `/settings/logistics/warehouselocation/setting/${warehouseUuid}`,
      name: warehouseName,
    });
    return uuid
      ? breadcrumbDataCopy.concat({
          url: '',
          name: getI18n('storeLogistics.courierAccount.editCourierAccount'),
        })
      : breadcrumbDataCopy.concat({
          url: '',
          name: getI18n('storeLogistics.courierAccount.addCourierAccount'),
        });
  }, [uuid, warehouseName]);

  const { loading: setCourierLoading, run: _setCourier } = useRequest(
    (params) => setCourier(params),
    {
      manual: true,
      onSuccess(result) {
        history.push(
          `/settings/logistics/warehouselocation/setting/${warehouseUuid}`,
        );
      },
    },
  );

  const { loading: getCourierDetailLoading, run: _getCourierDetail } =
    useRequest((uuid) => getCourierDetail(uuid), {
      manual: true,
      onSuccess(result) {
        const type = transformTypeRes(result.type);
        let defaultFields = {};
        switch (type) {
          case CourierType.SF:
            defaultFields = {
              ...result.qsfAccount,
              apiServerAddress:
                get(result.qsfAccount, 'apiServerAddress') || defaultAddress,
            };
            break;
          case CourierType.ZTO:
            defaultFields = result.ztoAccount;
            break;
        }
        form.setFieldsValue({
          ...defaultFields,
          name: result.name,
          waybillNumberAutoGenerate: result.waybillNumberAutoGenerate,
        });
      },
    });

  const onValuesChange = () => {
    if (onSaveDisable) {
      setOnSaveDisable(!onSaveDisable);
    }
  };

  const onFormSubmit = () => {
    form.validateFields().then((res) => {
      const { waybillNumberAutoGenerate, name, ..._params } = res;

      const params: any = {
        type: transformTypeReq(type),
        warehouse: { uuid: warehouseUuid },
        name,
        waybillNumberAutoGenerate,
      };

      switch (type) {
        case CourierType.SF:
          params.qsfAccount = { ..._params, location };
          break;
        case CourierType.ZTO:
          params.ztoAccount = _params;
          break;
      }

      if (uuid) {
        params.uuid = uuid;
      }

      // console.log('onFormSubmit: ', params);
      _setCourier(params);
    });
  };
  const goBackToList = () => {
    history.push(
      `/settings/logistics/warehouselocation/setting/${warehouseUuid}`,
    );
  };

  useEffect(() => {
    if (uuid && addressLoaded) {
      _getCourierDetail(uuid);
    }
    const courierShow =
      type == CourierType.SF
        ? `SF Express${location ? ` - ${location}` : ''}`
        : 'ZTO International';
    form.setFieldsValue({
      title: courierShow,
    });
  }, [uuid, addressLoaded]);

  return (
    <div className={styles.courierAccountSettingContainer}>
      <Spin
        spinning={
          locationLoading || setCourierLoading || getCourierDetailLoading
        }>
        <Form
          layout={'vertical'}
          form={form}
          className={styles.editForm}
          onValuesChange={onValuesChange}>
          <CommonHeader
            breadcrumbData={_breadcrumbData}
            onSaveDisable={onSaveDisable}
            onSubmit={onFormSubmit}
            onDiscard={goBackToList}
            onGoBackClick={goBackToList}
          />
          <div className={styles.courierAccountSettingContent}>
            <CourierAccountInformation />
            {CourierAccountStrategy[type]}
            {/* <WaybillNumber /> */}
            <ShippingLabel title={type} />
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default CourierAccountSetting;
